export default {
  page: {
    title: {
      base: 'Maksājumu vārteja Autopay',
      start: 'Maksājuma veida izvēle',
      result: 'Atkārtots BLIK maksājums',
      visadata: 'VisaMobile',
      continue: 'Turpināt — maksājuma veida izvēle',
      wait: 'Pagaidiet',
      confirmation: 'Maksājuma apstiprinājums',
      thankYou: 'Paldies par samaksu',
      error: 'Vietnes kļūda',
      errorNotFound: 'Lapa nav atrasta',
      secureBack: 'Iekrāvējs',
      maintenance: 'Apkope',
      regulationsApproval: 'Noteikumi un Privātuma politika',
      toTransferData: 'pārskaitījuma detaļas',
      sessionTimeout: 'Lapa pēc sesijas beigām',
      paywayError: 'Maksājumu kanāls nav pieejams'
    }
  },
  header: {
    availabilityAdjust: {
      increaseFontSize: 'Palieliniet fonta lielumu',
      decreaseFontSize: 'Samaziniet fonta lielumu',
      changeContrast: 'Mainiet kontrastu',
      changeLanguage: 'Mainiet vietnes valodu',
      skipToContent: 'Pāriet uz saturu',
      skipToContentLabel: 'Pāriet uz galveno saturu',
      logoTitle: 'Maksājumu vārteja Autopay',
      langLoading: 'Valodas ielāde',
      langChanged: 'Valoda ir mainīta'
    },
    sessionTimer: {
      timeOut: 'Sesija beidzās',
      sessionEnd: 'Sesijas beigas:',
      label: 'Pagariniet sesijas laiku',
      button: 'Pagarināt'
    }
  },
  footer: {
    text2: {
      part1: 'Personas datu pārzinis ir Autopay',
      part2: '6 Powstańców Warszawy Street, 81-718 Sopot. Personas datu sniegšana ir brīvprātīga, taču nepieciešama iesniegtā pieteikuma aizpildīšanai. Juridiskais pamats, mērķis, personas datu apstrādes periods un Lietotāja tiesības, kā arī cita svarīga informācija par personas datu apstrādes principiem ir detalizēti definēta <a href="{privacyPolicyUrl}" class="footer-text-link" target="_blank" title="Doties uz lapu ar Privātuma politikas dokumentu (128 KB, PDF)" rel="noreferrer">Automātiskā politika.">A>.</a>'
    },
    linkShowMoreTitle: 'Rādīt vairāk informācijas',
    linkShowMoreText: 'Lasīt vairāk',
    linkShowLessTitle: 'Rādīt mazāk informācijas',
    linkShowLessText: 'Lasi mazāk',
    help: {
      text1: 'Nepieciešama palīdzība?',
      text2: 'Vai jums ir jautājumi par tiešsaistes maksājumiem?',
      text3: '<a title="Atveras jaunā logā" href="https://pomoc.autopay.pl/?pk_campaign=paywall&pk_kwd=start&pk_medium=hyperlink" class="footer-text-link" target="_blank" rel="noreferrer">Dodieties uz palīdzības lapu</a>'
    }
  },
  paywall: {
    header: 'Izvēlieties maksājuma veidu',
    info: {
      paywayNotAvailable: 'Atvainojiet, bet šķiet, ka jūsu izvēlētais maksājuma veids pašlaik nav iespējams jūsu ierīcē.',
      applePayNotAvailable: 'Atvainojiet, bet šķiet, ka pašlaik jūsu ierīcē nav iespējams norēķināties ar Apple Pay.',
      googlePayNotAvailable: 'Atvainojiet, bet šķiet, ka pašlaik jūsu ierīcē nav iespējams norēķināties ar Google Pay.'
    },
    paywayGroup: {
      inactiveMessage: 'Maksājums pašlaik nav pieejams',
      notice: {
        novelty: 'JAUNS',
        promotion: 'AKCIJA',
        recommended: 'IETEICAMS',
        mastercard: 'ĀTRI UN DROŠI',
        mastercardC2P: 'ĀTRI UN DROŠI',
        blik: 'BLIKOMANIA – reģistrējies un laimē dimantus!',
        visaMobile: 'Maksājiet vienmērīgi un droši'
      },
      bank: {
        many: 'bankas',
        one: 'banka',
        two: 'bankas'
      },
      wallet: {
        many: 'maki',
        one: 'maku',
        two: 'maki'
      },
      otp: {
        many: 'veidus',
        one: 'veidā',
        two: 'veidus'
      },
      blikPayLater: {
        text1: 'Pērciet tūlīt, maksājiet 30 dienu laikā – bez papildu izmaksām. Ievadot BLIK kodu, jūs varat iegūt iepirkšanās limitu līdz 4000 PLN.',
        text2: 'Pakalpojums pieejams:'
      },
      blikAuto: {
        bankList: 'Pakalpojums pieejams:',
        infoModel0: 'Turpmākie maksājumi tiks automātiski norakstīti no jūsu konta.',
        infoModelM: 'Turpmākajiem maksājumiem būs nepieciešams tikai apstiprinājums jūsu bankas pieteikumā.'
      }
    },
    paywayList: {
      label: 'Maksājuma veidu grupa',
      linkSelectOther: 'Izvēlieties citu'
    },
    paywaySingle: {
      accountAtAnotherBank: 'Man ir konts citā bankā'
    },
    paywaySwitch: {
      methodShortSingle: 'Vienreizējās lietošanas',
      methodLongSingle: 'Vienreizēji maksājumi',
      methodShortAuto: 'Atkārtojas',
      methodLongAuto: 'Periodiski maksājumi'
    },
    form: {
      payway: {
        label: 'Izvēlieties savu maksājuma veidu',
        flowLabel: 'Maksājuma veids'
      },
      card: {
        label: 'Ievadiet kartes informāciju',
        flowLabel: 'Maksājumu karte',
        iframe: {
          title: 'Jāaizpilda kredītkartes datu veidlapa'
        }
      },
      visaMobile: {
        flowLabel: 'Tālruņa numurs',
        iframe: {
          title: 'Veidlapa ar tālruņa numuru, kas jāaizpilda'
        },
        status: {
          pending: {
            statusText: 'Gaida apstiprinājumu',
            header: 'Apstipriniet maksājumu lietotnē',
            descriptionText1: 'Maksājumu varat apstiprināt Visa Mobile lietotnē vai bankas lietotnē ar aktivizētu Visa Mobile',
            descriptionText2: 'Pēc darījuma apstiprināšanas lietotnē gaidiet maksājuma rezultātu',
            descriptionText3: 'Notiek darījuma atcelšana',
            cancelButton: 'Atcelt maksājumu'
          },
          success: {
            statusText: 'Paldies, ka veicāt pirkumu!',
            descriptionText: 'Maksājums veiksmīgi pabeigts'
          },
          error: {
            statusText: 'Pārliecinieties, vai Visa Mobile maksājumam izmantotajā maksājumu kartē ir pietiekami daudz līdzekļu.',
            descriptionText: 'Maksājums noraidīts'
          }
        },
        apps: 'Lietotnes, kas atbalsta Visa Mobile maksājumus',
        help: 'Vai jums ir vajadzīga palīdzība?',
        info: 'Uzziniet vairāk',
        secure: 'Drošs maksājums ar SSL šifrēšanu',
        modal2: {
          header: 'Lai apstiprinātu maksājumu, atveriet Visa Mobile lietotni vai tās bankas lietotni, kurā ir aktivizēta Visa Mobile',
          listText1: 'jūsu bankas mobilajā lietotnē ir instalēta Visa Mobile vai ir aktivizēta Visa Mobile',
          listText2: 'jums ir iespējoti paziņojumi pakalpojumā Visa Mobile vai bankas lietotnē ar iespējotu Visa Mobile',
          listText3: 'jūsu norādītais numurs ir pareizs: <strong class="no-wrap">+{prefix} {phone}</strong>',
          listText4: 'Tāpat pārliecinieties, ka...'
        }
      },
      click2pay: {
        loaderText: 'Mēs meklējam jūsu e-pasta adresi<br> sadaļā <strong>Noklikšķināt, lai samaksātu</strong>',
        saveCard: {
          text1: 'Saglabājiet savu karti',
          text2mc: 'Jūsu dati tiks droši saglabāti programmā <strong>Mastercard Click to Pay</strong>',
          text2visa: 'Jūsu dati tiks droši saglabāti pakalpojumā <strong>Visa Click to Pay</strong>',
          link: 'Uzziniet vairāk'
        },
        email: {
          labelForClick2Pay: 'E-pasta adrese maksājumu paziņojumiem'
        },
        cardSelect: {
          selected: 'Atlasīts',
          select: 'Izvēlieties',
          payOther: 'Ievadiet savas kartes informāciju',
          back: 'Atpakaļ'
        },
        cardSelected: {
          header: 'Izmantojiet karti, kas saglabāta pakalpojumā Click to Pay',
          date: 'derīga līdz',
          buttonChange: 'Mainīt'
        },
        codeForm: {
          description: 'Mēs atradām jūsu e-pasta adresi sadaļā Click to Pay.',
          codeSentEmail: 'Ievadiet vienreizējo kodu, ko nosūtījām uz {email}, lai pieteiktos savā kontā.',
          codeSentPhone: 'Ievadiet vienreizējo SMS kodu, ko nosūtījām uz {phone}, lai pieteiktos savā kontā.',
          codeSent: 'Ievadiet vienreizējo kodu, ko nosūtījām uz {validationChannel}, lai pieteiktos savā kontā.',
          codeLabel: 'Ievadiet kodu',
          codePlaceholder: 'ievadiet kodu',
          codeLabelFlow: 'Kods',
          codeSendLabel: 'Nosūtiet jaunu kodu',
          codeSendAriaLabel: 'izmantojot',
          codeSendAriaLabel2: 'vai',
          buttonSendNewSms: 'SMS',
          buttonSendNewEmail: 'e-pasts',
          trustedLabel: 'Pievienojiet šo ierīci savam uzticamo ierīču sarakstam<br><span>Nākamreiz mēs atpazīsim šo ierīci, un jūs maksāsit, nepiesakoties.</span>',
          buttonSubmit: 'Tālāk',
          buttonChangeCard: 'Ievadiet savas kartes informāciju'
        },
        info: {
          description: 'Maksājums ar karti ir šifrēts un drošs. Darījums tiks autorizēts, izmantojot 3DSecure bankas vietnē.'
        },
        loginForm: {
          emailLabel: 'Ievadiet savu e-pasta adresi, lai pieteiktos Click to Pay',
          emailPlaceholder: 'e-pasta adrese',
          emailLabelFlow: 'E-pasts',
          buttonSubmit: 'Piesakieties',
          buttonBack: 'Atpakaļ'
        },
        newUserForm: {
          header: 'Saglabājiet karti sadaļā Click to Pay',
          description: 'Lai saglabātu jūsu karti, mums ir nepieciešama papildu informācija.',
          emailLabel: 'Ievadiet e-pasta adresi',
          emailPlaceholder: 'e-pasta adrese',
          emailLabelFlow: 'E-pasts',
          countryLabel: 'Valsts',
          firstnameLabel: 'Vārds',
          firstnamePlaceholder: 'nosaukums',
          firstnameLabelFlow: 'Vārds',
          lastnameLabel: 'Uzvārds',
          lastnamePlaceholder: 'uzvārds',
          lastnameLabelFlow: 'Uzvārds',
          phoneLabel: 'Tālruņa numurs',
          phonePlaceholder: 'tālruņa numuru',
          phoneLabelFlow: 'Tālrunis',
          countryCodePlaceholder: 'kodu',
          countryCodeLabelFlow: 'Kods',
          trustedLabel: 'Pievienojiet šo ierīci savam uzticamo ierīču sarakstam<br><span>Nākamreiz mēs atpazīsim šo ierīci, un jūs maksāsit, nepiesakoties.</span>',
          termsMastercardLabel: 'Turpinot jūs piekrītat <a href="https://www.mastercard.com/global/click-to-pay/country-listing/terms.html" target="_blank">pakalpojumu sniegšanas noteikumiem</a> un saprotat, ka jūsu dati tiks apstrādāti saskaņā ar <a href="https://www.mastercard.com/global/click-to-pay/country.html-listing/privacy/privacy.html-"listing>. Mastercard.',
          termsVisaLabel: 'Turpinot jūs piekrītat <a href="{c2pVisaTermsUrl}" target="_blank">Visa Solution pakalpojumu sniegšanas noteikumiem</a> un saprotat, ka jūsu dati tiks apstrādāti saskaņā ar <a href="{c2pVisaPrivacyUrl}" target="_blank">Visa konfidencialitātes politiku</a>.',
          cookieVisaLabel: 'Turpinot jūs piekrītat <a href="{c2pVisaCookieUrl}" target="_blank">Visa sīkfailu politikai</a>.',
          c2pInfo: 'Jūsu e-pasts vai mobilā tālruņa numurs tiks izmantots, lai jūs apstiprinātu. Var tikt piemērota maksa par ziņojumiem/datiem.',
          buttonSubmit: 'Ietaupiet un maksājiet',
          buttonBack: 'Maksājiet, nesaglabājot karti'
        },
        profile: {
          header: 'Piesakieties, lai klikšķinātu, lai maksātu',
          buttonChangeEmail: 'Mainīt e-pasta adresi'
        },
        modal: {
          title: 'Noklikšķiniet, lai samaksātu - informācija',
          header: 'Maksājiet ātri un droši, atkārtoti neievadot kartes informāciju jaunajā Click to Pay standartā',
          text1: 'Maksājot ar karti, meklējiet logotipu <img src="/web/img/click2pay/Click_to_Pay.svg" style="height: 14px" alt="Click to Pay Logo"> un maksājiet ar kartes maksājumu ātri un ērti.',
          text2: 'Click To Pay ir jauns karšu maksājumu standarts, ko atbalsta Visa un Mastercard.',
          text3: 'Varat izmantot karti savā Click to Pay kontā, lai norēķinātos veikalos Polijā un ārvalstīs, atkārtoti neievadot kartes datus.',
          text4: 'Dati tiek droši glabāti Visa vai Mastercard kartē. Visa informācija ir pilnībā šifrēta.',
          text5: 'Turpmāko maksājumu laikā Click to Pay atpazīs jūsu e-pasta adresi, lai jūs uzreiz varētu norēķināties ar saglabātajām kartēm.',
          text6: 'Jūs papildus apstiprināt visus maksājumus savā bankā, kas garantē pilnīgu drošību.',
          processError: 'Apstrādājot jūsu Click to Pay maksājumu, radās kļūda. Veiciet standarta maksājumu ar karti.'
        }
      },
      email: {
        label: 'Norādiet savu e-pasta adresi',
        flowLabel: 'E-pasts',
        tip: 'Mums ir nepieciešama jūsu e-pasta adrese, lai mēs varētu jums nosūtīt ziņojumus par jūsu maksājuma statusu.',
        fuse: 'Lūdzu, pārliecinieties, ka jūsu e-pasta adrese ir ievadīta pareizi.'
      },
      blikCode: {
        label: 'Ievadiet BLIK kodu',
        flowLabel: 'CAN kods'
      },
      terms: {
        header: 'Piekrišana un paziņojumi',
        selectAll: 'Atlasiet visu',
        fieldNotRequired: 'Neobligāts lauks',
        partnerMarketingTextLess: 'Vai vēlaties saņemt no mums e-pastā, SMS vai tālruņa brīdinājumus par mūsu vai mūsu partneru organizētajiem labākajiem piedāvājumiem, akcijām, konkursiem un citiem interesantiem pasākumiem?',
        partnerMarketingTextMore: 'Mēs apsolām nesūtīt surogātpastu! Ja jums ir garlaicīgi ar mūsu ziņojumiem, jūs jebkurā laikā varat atsaukt savu piekrišanu.',
        tradeMarketingTextLess: 'Vai vēlaties, lai mēs nodotu jūsu e-pastu vai tālruņa numuru mūsu uzticamajiem partneriem, lai viņi varētu sniegt jums interesantu informāciju un piedāvājumus?',
        tradeMarketingTextMore: 'Mēs nodrošinām, ka mūsu partneri ir cienījami uzņēmumi, kuriem, tāpat kā mums, nepatīk surogātpasta sūtīšana, un jūs jebkurā laikā varat atsaukt savu piekrišanu.'
      },
      termsFlowLabel: 'Noteikumi',
      termsLabelDefault: 'Esmu izlasījis(-usi) un piekrītu <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Lejupielādēt failu ar pakalpojuma noteikumiem" rel="noreferrer">Noteikumiem</a> maksājumu pakalpojumu sniegšanai un <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Lejupielādēt failu ar Autopay S.A. privātuma politiku">Privātuma politikai</a>. Vēlos, lai pakalpojums tiktu ieviests nekavējoties, un līguma atcelšanas gadījumā zinu, ka pēc mana pieprasījuma nesaņemšu atmaksu par sniegtajiem pakalpojumiem, kamēr neatteikšos no līguma.',
      termsReccuring: 'Ja vēlaties veikt maksājumu, lūdzu, piekrītiet <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">Pakalpojumu sniegšanas noteikumiem</a> un <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="Autopacy Policy"</a>">Lejupielādējiet privātuma politikas failu.A.A. Autopay S.A., piekrišana tūlītējam maksājuma pakalpojumam un piekrišana iekasēt maksu no manas maksājumu kartes.',
      termsReccuringMore1: 'Es piekrītu pakalpojuma sniegšanai nekavējoties un apliecinu, ka atteikšanās no līguma gadījumā man netiks atlīdzinātas izmaksas, kas radušās par pakalpojumiem, kas sniegti pēc mana pieprasījuma pirms manas atteikšanās no līguma.',
      termsReccuringMore2: 'Ar šo es piekrītu, ka Autopay S.A. regulāri iekasē maksu no manas maksājumu kartes, lai veiktu darījumu {receiverName} labā. Kartes periodiskās maksas noteikumi ir noteikti <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the terms of service file" rel="noreferrer">maksājumu pakalpojumu sniegšanas noteikumos</a>. Ar šo apliecinu, ka zinu periodus, biežumu un noteikumus, kas attiecas uz manas maksājumu kartes iekasēšanas summu, kā arī šīs piekrišanas atsaukšanas veidu, ko esmu noteicis ar {receiverName}. Es sazināšos ar {receiverName}, ja jums ir kādi jautājumi par periodisko maksājumu no maksājumu kartes.',
      mwfClauseLess: 'Ja vēlaties veikt maksājumu, piekrītiet <a href="{regulationUrl}" class="form-text-link" target="_blank" title="Download the file with the Terms of Service" rel="noreferrer">pakalpojumu sniegšanas noteikumiem</a> un <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank"">Privātuma politikas faila lejupielāde ar S.cy automātiskās lejupielādes politiku. Autopay S.A.</a>, piekrītiet sākt darījumu jūsu bankā, izmantojot Autopay S.A., un sniedziet informāciju par šo darījumu saņēmējam un pieprasiet tūlītēju maksājumu pakalpojuma izpildi.',
      mwfClauseMore: 'Vēlos, lai pakalpojums tiktu sniegts nekavējoties un zinu, ka atteikšanās no līguma gadījumā radušos izdevumus nesaņemšu.',
      mwfClauseARIA: 'Ja vēlaties veikt maksājumu, piekrītiet Autopay S.A. noteikumiem un privātuma politikai, piekrītiet uzsākt darījumu savā bankā, izmantojot Autopay S.A., un sniedziet saņēmējam informāciju par šo darījumu un pieprasiet tūlītēju maksājumu pakalpojuma izpildi. Vēlos, lai pakalpojums tiktu sniegts nekavējoties un zinu, ka atteikšanās no līguma gadījumā radušos izdevumus nesaņemšu. <a href="{regulationUrl}" class="form-text-link" target="_blank" title="" rel="noreferrer" tabindex="-1">Lejupielādēt failu ar pakalpojumu sniegšanas noteikumiem</a> <a href="{privacyPolicyUrl}" class="form-text-link" target="_blank" title="" tabindex="-1">Automātiski lejupielādēt S. politikas failu</a>.</a>.',
      paymentInfo: 'Maksājuma uzdevums tiek iesniegts jūsu bankai, izmantojot Sopotā bāzēto uzņēmumu Autopay S.A., un tas tiks apstrādāts saskaņā ar jūsu bankas noteiktajiem noteikumiem. Pēc bankas izvēles jūs autorizēsiet maksājumu.',
      changePaywayLink1: 'Jūs joprojām varat',
      changePaywayLink2: 'mainīt maksājuma veidu',
      linkMore: 'VAIRĀK',
      linkShowMoreTitle: 'Parādiet papildu informāciju',
      linkLess: 'MAZĀK',
      linkShowLessTitle: 'Slēpt papildu informāciju',
      submitButton: {
        visaMobile: 'Maksāt līdz',
        fastTransfer: 'Ģenerējiet pārsūtīšanas informāciju',
        mwf: 'Pieņemu un maksāju',
        pis: 'Pieņemu un sāku maksājumu',
        auto: 'Pasūtiet periodisku maksājumu',
        autoPayment: 'Pasūtījuma apmaksa',
        other: 'Maksājiet tagad',
        orange: 'Apstiprināt',
        c2pNext: 'Tālāk',
        c2pAccept: 'es pieņemu',
        c2pSaveAndPay: 'Ietaupiet un maksājiet',
        ariaLabelInactive: 'Lai turpinātu, lūdzu, pareizi aizpildiet obligātos laukus'
      }
    },
    frData: {
      pageTitle: 'Detalizēti dati pārsūtīšanai',
      header: 'Pasūtiet pārskaitījumu, izmantojot norādīto informāciju',
      nrbLabel: 'Saņēmēja konts',
      nameLabel: 'Saņēmēja vārds',
      addressLabel: 'Saņēmēja adrese',
      titleLabel: 'Pārsūtīšanas nosaukums',
      amountLabel: 'Pārskaitījuma summa',
      timeLabel: 'Veikt darījumu līdz',
      linkCopy: 'Kopēt',
      linkGetPdf: 'Lejupielādēt PDF ar datiem',
      linkGetPdfTitle: 'Tas tiek atvērts jaunā logā',
      linkGoToBank: 'Piesakieties bankā',
      info: 'Piesakieties savā bankas kontā. Kopējiet datus pārsūtījumā. Svarīgi, lai rekvizīti būtu vienādi, nemainītu summu, valūtu vai nosaukumu utt.',
      verifyInfo: 'Jūsu bankas verifikācija var ilgt līdz 3 dienām, jo nevarat apstrādāt ātru pārskaitījumu. Varat turpināt vai arī varat verificēt savu bankas kontu citā veidā. Ja vēlaties izvēlēties citu metodi, noklikšķiniet uz <strong>{backToShopText}</strong> un atgriezieties Fortuna vietnē.'
    },
    frInfo: {
      paywall: {
        text1: 'Vai maksājat no ārzemju konta?',
        text2: 'Lūdzu, pārliecinieties, vai pārskaitījuma summa un mērķis atbilst sniegtajai informācijai. Noteikti norādiet savas bankas komisijas maksu. Nepareiza informācija neļaus maksājumam sasniegt pārdevēju.'
      },
      frData: {
        text1: 'Lūdzu, ievadiet informāciju precīzi — bez izmaiņām.',
        text2: 'Cita summa vai PĀRSKAITĪJUMA NOSAUKUMS novedīs pie tā, ka maksājums netiks piešķirts pasūtījumam.'
      }
    },
    processing: {
      pageTitle: 'Gaidīšanas lapa darījuma apstrādei',
      loaderAnimation: 'Gaidīšanas laikā tiek rādīta animācija',
      header: 'Mēs sagatavojam jūsu maksājumu lapu.',
      description: 'Lūdzu, uzgaidiet mirkli...',
      info: {
        header: 'Piezīme!',
        description: 'Neaizveriet lapu pēc darījuma pabeigšanas – pretējā gadījumā jūsu nauda netiks nosūtīta saņēmējam.'
      },
      loaderText: 'Notiek datu pārsūtīšana.<br>Tas aizņems ne vairāk kā 30 sekundes.'
    },
    paymentBoost: {
      button: 'rādīt vairāk maksājuma veidu'
    }
  },
  thankYou: {
    pageTitle: 'Informācija par darījuma rezultātu',
    form: {
      emailLabel: 'E-pasts',
      buttonSubmit: 'Atgriezties uz partnera lapu'
    },
    negative: {
      header: 'Maksājums netika apstrādāts, jo nebija darījuma autorizācijas.',
      description: 'Ja tomēr vēlaties izmantot konkrēta mazumtirgotāja vai pakalpojumu sniedzēja piedāvājumu – atgriezieties viņu mājaslapā, izvēlieties preci vai pakalpojumu un veiciet apmaksu, izmantojot sev izvēlēto metodi.'
    },
    pending: {
      header: 'Paldies, ka pasūtījāt maksājumu, izmantojot maksājumu vārteju',
      description: 'Notiek darījuma statusa pārbaude. Kad process būs pabeigts, savā e-pasta iesūtnē saņemsiet informāciju par maksājuma statusu.'
    },
    positive: {
      header: 'Paldies, jūsu maksājums ir apstrādāts.',
      description: 'Mēs nosūtīsim apstiprinājumu uz jūsu norādīto e-pasta adresi.'
    }
  },
  regulationsApproval: {
    header: 'Pieņemiet darījumu'
  },
  wait: {
    pageTitle: 'Gaidīšanas lapa'
  },
  sessionTimeout: {
    pageTitle: 'Lapa pēc sesijas beigām',
    header: 'Maksājuma izpildes laiks ir pagājis',
    description: 'Jūs jebkurā laikā varat atgriezties partnera vietnē, atkārtoti pasūtīt vai izmantot pakalpojumu un veikt maksājumu, izmantojot jūsu izvēlēto metodi.'
  },
  paywayError: {
    pageTitle: 'Atlasītais maksājumu kanāls nav pieejams',
    header: 'Diemžēl izvēlētais maksājuma veids pašlaik nav pieejams.',
    description: 'Lūdzu, atgriezieties partnera lapā un vēlāk mēģiniet vēlreiz.'
  },
  loader: {
    loading: 'Ielāde',
    rateLimitExceeded: 'Ir palielināta darījumu trafika, tāpēc maksājuma apstrāde var aizņemt ilgāku laiku nekā parasti. Lūdzu, uzgaidiet un neatsvaidziniet maksājumu lapu.'
  },
  result: {
    pending: {
      header: 'Apstipriniet atkārtoto BLIK maksājumu',
      description: 'Atveriet savu bankas lietotni un apstipriniet maksājumu'
    },
    positive: {
      initWithPayment: {
        header: 'Apmaksāts',
        description: 'Mēs esam pārskaitījuši jūsu līdzekļus saņēmējam. Jūs saņemsiet no tirgotāja vai pakalpojumu sniedzēja galīgo apstiprinājumu par BLIK periodiskā maksājuma aktivizēšanu.',
        button: 'Atgriezties uz vietni'
      },
      initWithRefund: {
        header: 'Gatavs',
        description1: 'Esam saņēmuši jūsu pasūtījumu un nosūtījuši to apstrādei. Jūs saņemsiet galīgo apstiprinājumu tieši no veikala.',
        description2: 'Summa {amount} {currency} tiks atmaksāta jūsu bankas kontā.',
        button: 'Atgriezties uz vietni'
      },
      initWithoutPayment: {
        header: 'Gatavs',
        description: 'Mēs iespējojam atkārtotus BLIK maksājumus. Drīzumā jūs saņemsit informāciju no {shopName}.',
        button: 'Atgriezties uz vietni'
      }
    },
    negative: {
      recurrencyNotSupported: {
        header: 'Nevar iespējot BLIK periodisko maksājumu',
        description1: 'Jūs nevarat iespējot BLIK periodiskos maksājumus. Šī metode pašlaik nav pieejama jūsu bankas lietotājiem.',
        description2: 'Mēģiniet vēlreiz, izmantojot BLIK kodu ar atbalstītajām bankām, vai izvēlieties citu maksājuma veidu.',
        buttonContinue: 'Mainiet maksājuma veidu',
        buttonReturn: 'Atgriezties uz vietni'
      },
      wrongTicket: {
        header: 'Nepareizs BLIK kods',
        description: 'Ievadītais BLIK kods ir nepareizs vai tam ir beidzies derīguma termiņš. Lūdzu, pārbaudiet kodu un mēģiniet vēlreiz. Ja problēma joprojām pastāv, ģenerējiet jaunu kodu savā bankas lietotnē.',
        buttonContinue: 'Mainiet maksājuma veidu',
        buttonReturn: 'Atgriezties uz vietni'
      },
      generic: {
        header: 'Nevar iespējot BLIK periodisko maksājumu',
        description: 'Jūs nevarat iespējot BLIK periodiskos maksājumus. Mēģiniet vēlreiz, izmantojot BLIK kodu ar atbalstītajām bankām, vai izvēlieties citu maksājuma veidu.',
        buttonContinue: 'Mainiet maksājuma veidu',
        buttonReturn: 'Atgriezties uz vietni'
      }
    },
    pageTitle: 'Atkārtots BLIK maksājums'
  },
  orderDetails: {
    header: 'Sīkāka informācija',
    headerAriaLabel: 'Darījuma informācija',
    amountLabel: 'Maksājamā summa',
    receiverLabel: 'Saņēmējs',
    orderLabel: 'Pasūtījuma numurs',
    amountOriginalCurrencyLabel: 'Sākotnējā summa',
    currencyRateLabel: 'Valūtas maiņas kurss',
    feeLabel: 'Maksa par darījumu apstrādi',
    feeLabelDcc: 'Valūtas konvertācijas maksa',
    customerNumberLabel: 'Klienta numurs',
    invoiceNumberLabel: 'Rēķina numurs',
    accountNumberLabel: 'Konta numurs',
    paywayLabel: 'Maksājuma veids',
    paywayName: 'Tiešsaistes bankas pārskaitījums',
    linkBack: 'Atpakaļ uz veikalu',
    linkBackTitle: 'Atstājiet darījumu un dodieties atpakaļ uz veikalu',
    linkMore: 'parādīt vairāk',
    linkLess: 'rādīt mazāk',
    toggleBtnUnfoldAriaLabel: 'Izvērsiet pasūtījuma informāciju',
    toggleBtnFoldAriaLabel: 'Sakļaut pasūtījuma informāciju',
    blikReccuringNameLabel: 'Vārds',
    blikReccuringValidToLabel: 'Derīguma termiņš',
    blikReccuringValidToText: 'Uz nenoteiktu laiku',
    blikReccuringFrequencyLabel: 'Biežums',
    blikReccuringFrequencyText: 'Katru reizi, kad izmantojat pakalpojumu'
  },
  error: {
    pageTitle: 'Kļūdas lapa',
    linkBackUrlSet: 'Atgriezties uz partnera vietni',
    linkBackUrlNotSet: 'Dodieties uz palīdzības lapu',
    sessionTimeout: {
      title: 'Maksājuma izpildes laiks ir pagājis',
      message: 'Jūs jebkurā laikā varat atgriezties partnera vietnē, atkārtoti pasūtīt vai izmantot pakalpojumu un veikt maksājumu, izmantojot jūsu izvēlēto metodi.'
    },
    notFoundError: {
      pageTitle: 'Kļūdas lapa 404 — lapa nav atrasta',
      title: 'Šķiet, ka esat aizbraucis pārāk tālu un nevarējāt atrast lapu, kuru vēlaties apmeklēt.',
      message: 'Iespējamie cēloņi: lapa neeksistē vai ir noņemta, tiek veikta apkope, lapas adrese ir nepareiza, radusies tehniska kļūda.'
    },
    generalError: {
      title: 'Atvainojiet',
      message: 'Pašlaik mēs nevaram apstrādāt jūsu pārskaitījumu.'
    },
    errFieldNotFound: {
      title: 'Atvainojiet',
      message: ''
    },
    errBadClientSource: {
      title: 'Atvainojiet',
      message: ''
    },
    nrParametersError: {
      title: 'Atvainojiet',
      message: 'Pašlaik mēs nevaram apstrādāt jūsu pārskaitījumu.'
    },
    transactionOutdated: {
      title: 'Laiks maksājuma pabeigšanai ir pagājis.',
      message: 'Pasūtiet to vēlreiz.'
    },
    linkValidityTimeOutdated: {
      title: 'Laiks maksājuma pabeigšanai ir pagājis.',
      message: 'Pasūtiet to vēlreiz.'
    },
    transactionValidityTimeOutdated: {
      title: 'Laiks maksājuma pabeigšanai ir pagājis.',
      message: 'Pasūtiet to vēlreiz.'
    },
    multiplyTransaction: {
      title: 'Atvainojiet',
      message: 'Darījums jau pastāv un gaida maksājumu.'
    },
    transactionCanceled: {
      title: 'Atvainojiet',
      message1: 'Darījums tika atcelts.',
      message2: 'Pasūtiet to vēlreiz.'
    },
    multiplyPaidTransaction: {
      title: 'Atvainojiet',
      message: 'Darījums jau ir apmaksāts.'
    },
    transactionReject: {
      title: 'Atvainojiet',
      message1: 'Hmm, kaut kas nogāja greizi.',
      message2: 'Notiek labošana...'
    },
    bankDisabled: {
      title: 'Atvainojiet',
      message: 'Atlasītā banka pašlaik nav pieejama.'
    },
    bankTemporaryMaintenance: {
      title: 'Atvainojiet',
      message: 'Pašlaik mēs nevaram apstrādāt jūsu pārskaitījumu.'
    },
    insufficientStartAmount: {
      title: 'Atvainojiet',
      message: 'Pārskaitījuma summas limits ir pārsniegts.'
    },
    startAmountOutOfRange: {
      title: 'Atvainojiet',
      message: 'Pārskaitījuma summas limits ir pārsniegts.'
    },
    nonAccountedLimitExceeded: {
      title: 'Atvainojiet',
      message: 'Maksājumu nevar apstrādāt, jo pārdevējs ir sasniedzis mēneša pārdošanas limitu.'
    }
  },
  confirmation: {
    pageTitle: 'Informācija par apmaksas procesu',
    linkBack: 'Es atgriezīšos vietnē',
    linkBackTimeout: 'Atgriezties uz partnera vietni',
    linkBackTimeoutTime: 'sekundes',
    linkBackAutoRedirect: 'Šī lapa tiks automātiski novirzīta uz partnera vietni pēc {time} sekundēm. Mijiedarbība ar lapu apturēs atpakaļskaitīšanu.',
    linkBackTimerStopped: 'Automātiskā novirzīšana ir apturēta. Lai atgrieztos uz partnera vietni, izmantojiet pogu Atgriezties uz vietni.',
    incorrectAmount: {
      header: 'Nepareiza summa',
      description: 'Mēs nepārskaitījām jūsu maksājumu adresātam, jo summa bija nepareiza.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to. Atcerieties, ka nedrīkst mainīt datus.'
    },
    multiplePaid: {
      header: 'Divkāršs depozīts',
      description: 'Saņēmējs saņēma jūsu maksājumu divas reizes. Neuztraucieties — jūs saņemsiet atmaksu.',
      description2: 'Sazinieties ar saņēmēju un sniedziet viņam maksājuma apstiprinājumu.'
    },
    negative: {
      header: 'Nav maksājuma',
      description: 'Apstrādājot jūsu maksājumu, radās kļūda. Bet nekas nav zaudēts.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to.'
    },
    notFound: {
      header: 'Nav maksājuma',
      description: 'Apstrādājot jūsu maksājumu, radās kļūda. Bet nekas nav zaudēts.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to.'
    },
    outdated: {
      header: 'Laika beigas',
      description: 'Mēs nepārskaitījām jūsu maksājumu saņēmējam.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to.'
    },
    outdatedPaidNotRefunded: {
      header: 'Laika beigas',
      description: 'Mēs nepārskaitījām jūsu maksājumu saņēmējam. Ja nauda ir izņemta no jūsu konta, neuztraucieties, jūs saņemsit atmaksu dažu dienu laikā.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to.'
    },
    outdatedPaidRefunded: {
      header: 'Laika beigas',
      description: 'Mēs nepārskaitījām jūsu maksājumu saņēmējam. Ja nauda tika izņemta no jūsu konta, neuztraucieties, mēs to jau esam atmaksājuši.',
      description2: 'Noklikšķiniet uz pogas, lai atgrieztos lapā un atkārtotu to.'
    },
    pending: {
      header: 'Notiek',
      description: 'Mēs apstrādājam jūsu maksājumu. Mēs jūs informēsim, kad tas sasniegs adresātu.'
    },
    positive: {
      header: 'Apmaksāts',
      visaVideo: 'Reklāmas video atskaņots pēc veiksmīga darījuma',
      description: 'Mēs esam pārskaitījuši jūsu līdzekļus saņēmējam.',
      dccStatement: 'Man tika dota iespēja izvēlēties valūtas, kas tiks izmantotas manam maksājumam. Es izvēlējos darījuma valūtu un piekritu maksāt {currency} pēc norādītā valūtas kursa. Dinamisko valūtas konvertāciju (DCC) nodrošina Autopay S.A.'
    }
  },
  messages: {
    accessForbidden: 'Nav piekļuves',
    internalServerError: 'Radās neparedzēta kļūda. Vēlāk mēģiniet vēlreiz.',
    validators: {
      required: 'Obligāts lauks',
      pattern: 'Lūdzu, norādiet derīgu vērtību',
      blikCode: 'Ievadiet 6 ciparu BLIK kodu',
      emailRequired: 'Lūdzu, norādiet pareizo e-pasta adresi',
      emailNotValid: 'Lūdzu, norādiet pareizo e-pasta adresi',
      emailNotRecognized: 'Norādītā e-pasta adrese nav reģistrēta',
      emailIdentityLookup: 'E-pasta adresi nevarēja verificēt',
      emailLocked: 'Norādītā e-pasta adrese Mastercard sistēmā ir īslaicīgi bloķēta',
      paywayRequired: 'Lai samaksātu, izvēlieties banku',
      creditCardRequired: 'Aizpildiet visus laukus',
      phoneRequired: 'Lūdzu, ievadiet derīgu tālruņa numuru',
      regulationRequired: 'Piekrītiet Noteikumiem un nosacījumiem',
      requiredConsent: 'Nepieciešama piekrišana',
      codeNotValid: 'Norādītais kods nav derīgs',
      codeAccountLocked: 'Konts ir īslaicīgi bloķēts',
      unknownError: 'Radās neparedzēta kļūda'
    },
    validatorsAria: {
      required: 'Uzmanību. Veidlapas lauks nav aizpildīts. Obligāts lauks',
      pattern: 'Uzmanību. Laukā ir nederīga vērtība.',
      blikCode: 'Uzmanību. Ievadiet 6 ciparu BLIK kodu',
      emailRequired: 'Uzmanību. E-pasta lauks nav aizpildīts. Lūdzu, norādiet pareizo e-pasta adresi',
      emailNotValid: 'Uzmanību. Jūsu e-pasta adresē ir kļūda. Lūdzu, norādiet pareizo e-pasta adresi',
      emailNotRecognized: 'Uzmanību. Norādītā e-pasta adrese nav reģistrēta.',
      emailIdentityLookup: 'Uzmanību. Norādīto e-pasta adresi nevarēja verificēt.',
      emailLocked: 'Uzmanību. Norādītā e-pasta adrese Mastercard sistēmā ir īslaicīgi bloķēta.',
      paywayRequired: 'Uzmanību. Maksājums nav izvēlēts. Izvēlieties maksājuma veidu',
      creditCardRequired: 'Uzmanību. Aizpildiet visus laukus ar kredītkartes informāciju',
      phoneRequired: 'Uzmanību. Tālruņa numura laukā ir kļūda. Lūdzu, ievadiet derīgu tālruņa numuru.',
      codeNotValid: 'Uzmanību. Norādītais kods nav derīgs.',
      codeAccountLocked: 'Uzmanību. Konts ir īslaicīgi bloķēts.',
      unknownError: 'Uzmanību. Radās neparedzēta kļūda.'
    },
    success: {
      copy: 'Kopēts!',
      codeSent: 'Kods ir nosūtīts!'
    },
    errors: {
      getPdf: 'Neizdevās lejupielādēt PDF!',
      copy: 'Neizdevās nokopēt!',
      thankYouUpdate: 'Neizdevās saglabāt e-pasta adresi!',
      groupInactive: 'Pašlaik nav iespējams veikt pārsūtīšanu, izmantojot grupu {groupName}. Lūdzu, atlasiet citu maksājuma veidu.',
      paywayInactive: 'Šobrīd tehnisku iemeslu dēļ nav iespējams veikt pārskaitījumu no izvēlētās bankas. Lūdzu, atlasiet citu banku vai maksājuma veidu.',
      googlePayInactiveTitle: 'Google Pay šajā ierīcē nav pieejama',
      applePayInactiveTitle: 'Apple Pay šajā ierīcē nav pieejama',
      applePayCancelTitle: 'Maksājums netika pabeigts',
      applePayCancel: 'Maksājums netika apstiprināts. Mēģiniet vēlreiz vai izvēlieties citu metodi.',
      googlePayInactive: 'Diemžēl Google Pay maksājums jūsu ierīcē nav pieejams.',
      applePayInactive: 'Apple Pay ir pieejams cilvēkiem, kuri izmanto Safari un iOS ierīces.',
      codeNotSent: 'Neizdevās atkārtoti nosūtīt kodu!',
      codeCounterExceeded: 'Ir pārsniegts atļautais mēģinājumu skaits. Ievadiet kartes datus manuāli vai izmantojiet citu maksājuma veidu.'
    }
  },
  modal: {
    closeButton: 'Aizvērt',
    confirmButton: 'es saprotu'
  },
  configuration: {
    paywayGroups: {
      auto: {
        label: 'Periodisks maksājums',
        description: 'Ievadiet tās kartes datus, ko izmantosiet apmaksai. Automātiskie maksājumi tiks noņemti no jūsu kartes vēlāk.',
        labelInitWithRefund: 'Verifikācijas maksājums',
        labelInitWithRefundOrange: 'Pievienot maksājumu karti',
        labelInitWithPayment: 'Kartes apmaksa',
        descriptionInitWithRefund: 'Ievadiet tās kartes informāciju, kuru vēlaties verificēt turpmākajiem maksājumiem. Nākamajā solī no dotās kartes iekasēsim 1 PLN, lai pārbaudītu datu pareizību. Pēc pārbaudes mēs atmaksāsim summu.',
        descriptionInitWithPayment: 'Ievadiet tās kartes datus, ko izmantosiet darījuma veikšanai, un vienlaikus pārbaudiet to turpmākajiem maksājumiem.'
      },
      blik: {
        label: 'SKATIES',
        description: 'Maksājiet uzreiz, ievadot BLIK kodu, bez pieteikšanās vai reģistrācijas'
      },
      blikAuto: {
        label: 'BLIK periodiskie maksājumi',
        description: 'Šim tirgotājam varat iespējot periodiskos BLIK maksājumus, un turpmākie maksājumi tiks automātiski atskaitīti no jūsu konta.'
      },
      card: {
        label: 'Kartes apmaksa',
        description: 'Maksājiet ar savu bankas karti'
      },
      pbl: {
        label: 'Tiešsaistes pārsūtīšana',
        description: 'Izvēlieties banku, kurā vēlaties veikt maksājumu',
        descriptionVerify: 'Tiešsaistes identitātes pārbaude',
        descriptionServiceVerify: 'Izvēlieties banku, kas ļaus jums pārbaudīt tiešsaistes pakalpojumu'
      },
      visaMobile: {
        label: 'VisaMobile',
        description: 'Visa Mobilais maksājums'
      },
      wallet: {
        label: 'Google&nbsp;Pay | Apple&nbsp;Pay',
        description: 'Maksājiet bez nepieciešamības pieteikties internetbankā'
      },
      installments: {
        label: 'Nomaksa',
        description: 'Maksājiet par pirkumiem, izmantojot ērtas nomaksas.'
      },
      alior: {
        descriptionInfo1: 'Maksājiet par pirkumiem, izmantojot ērtas nomaksas.',
        descriptionInfo2: '(pārbaudiet informāciju)',
        aliorModal: {
          text1: 'Atkarībā no vietnes iestatījumiem, kurā veicat pirkumu, varat iegādāties preces uz nomaksu šādos variantos:',
          text2: '<ul><li>10 iemaksas 0%</li><li>20 iemaksas 0%</li><li>no 3 līdz 48 maksām ar ikmēneša maksu 1% (saskaņā ar konkrētam darījumam sniegto reprezentatīvo piemēru)</li></ul>'
        }
      },
      otp: {
        label: 'Maksājiet vēlāk',
        description: 'Pērciet tagad un maksājiet vēlāk',
        descriptionInfo1Mwf: 'Apmaksājiet rēķinu vēlāk - vienu reizi līdz 45 dienām vai vairākās vienādās daļās',
        descriptionInfo1Ecommerce: 'Maksāt vēlāk – vienu reizi līdz 45 dienām vai vairākās vienādās daļās',
        descriptionInfo2Mwf: 'Informācija par kredīta starpnieku un izmaksām',
        descriptionInfo2Ecommerce: 'Informācija par izmaksām',
        labelPayka: 'Viņš ir',
        descriptionPayka: 'Apmaksājiet rēķinu vēlāk — vienu reizi līdz 30 dienām vai 4 vienādās daļās <a href="" id="paykaShowInModal">Informācija par kredīta starpnieku un izmaksām</a>',
        paykaModalMwf: {
          header1: 'Aizdevuma brokera paziņojums',
          text1: 'Autopay S.A., kuras galvenā mītne atrodas Sopotā, darbojas kā aizdevuma brokeris uzņēmumam Paytree S.A., kura galvenā mītne atrodas Gdaņskā, Polijā (aizdevējs), kas ir pilnvarota iepazīstināt klientus ar aizdevuma piedāvājumu un novirzīt uz aizdevēja vietni, tostarp aizdevuma pieteikumu. Plašāku informāciju par piedāvājumu skatiet vietnē <a href="https://payka.pl/rachunki-domowe" target="_blank">Mājsaimniecības rēķini — Payka</a>.',
          header2: 'Informācija par izmaksām',
          text2: 'Maksāt vēlāk – vienu reizi līdz 45 dienām vai vairākās vienādās daļās. Izmaksu dati reprezentatīvam piemēram: Atmaksa 45 dienu laikā GPL 0%; Nomaksas atmaksa GPL 74,11%. Sīkāka informācija par piedāvājumu: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        },
        paykaModalEcommerce: {
          header2: 'Informācija par izmaksām',
          text2: 'Maksāt vēlāk – vienu reizi līdz 45 dienām vai vairākās vienādās daļās. Izmaksu dati reprezentatīvam piemēram: Atmaksa 45 dienu laikā GPL 0%; Nomaksas atmaksa GPL 74,11%. Sīkāka informācija par piedāvājumu: <a href="https://payka.pl" target="_blank">Payka.pl</a>'
        }
      },
      blikPayLater: {
        label: 'BLIK Maksā vēlāk',
        description: ''
      },
      companyPayments: {
        label: 'Biznesa maksājums',
        description: 'Atlikiet maksājuma datumu uzņēmuma pirkumiem par 30 dienām'
      },
      transfer: {
        label: 'Pārsūtīšanas informācija',
        description: 'Pasūtiet pārskaitījumu, izmantojot norādīto informāciju'
      },
      other: {
        label: 'Cits',
        description: ''
      }
    },
    mobileEvents: {
      statusDescription: {
        bankDisabled: 'Atvainojiet. Pašlaik mēs nevaram apstrādāt jūsu pārskaitījumu. Atlasītā banka pašlaik nav pieejama.',
        blockMultipleTransactions: 'Atvainojiet. Darījums jau pastāv un gaida maksājumu.',
        blockPaidTransactions: 'Atvainojiet. Par darījumu jau ir samaksāts. Jūs nevarat veikt maksājumu vēlreiz.',
        canceledTransactions: 'Darījums, par kuru mēģināt maksāt, ir atcelts un nav pieejams. Lūdzu, sāciet jaunu darījumu.',
        declined: 'Autorizācijas atteikums.',
        generalError: 'Radās īslaicīga savienojuma problēma. Pašlaik mēs nevaram apstrādāt jūsu pārskaitījumu. Lūdzu, atgriezieties vēlāk.',
        insufficientStartAmount: 'Atvainojiet. Pārskaitījuma summas limits ir pārsniegts.',
        internalServerError: 'Upsss... darbība neizdevās:(. Mēs strādājam pie problēmas risināšanas. Vēlāk mēģiniet vēlreiz.',
        nonAccountedLimitExceeded: 'Maksājumu nevar apstrādāt, jo pārdevējs ir sasniedzis mēneša pārdošanas limitu.',
        outdatedError: 'Maksājuma pabeigšanas laiks ir pagājis..',
        paid: 'Darījums ir veiksmīgi pabeigts.',
        paywayLoaded: 'Ātrās pārsūtīšanas lapa ir ielādēta',
        paywaylistLoaded: 'Maksājuma veida atlases lapa ir ielādēta'
      }
    }
  },
  maintenance: {
    text1: 'Notiek Autopay maksājumu vārtejas Jaungada tīrīšana, kā rezultātā šobrīd nav iespējams pasūtīt maksājumus. Atvainojamies par sagādātajām neērtībām.',
    text2: 'Vārteja atkal sāks darboties jau 16. janvārī plkst. 10.',
    text3: 'Paldies par sapratni.'
  },
  requiredParams: {
    accountHolderName: {
      label: 'Ievadiet konta īpašnieka informāciju',
      flowLabel: 'Konta īpašnieks',
      placeholder: 'Ievadiet konta īpašnieka informāciju'
    },
    nip: {
      label: 'Ievadiet savu nodokļu maksātāja identifikācijas numuru',
      flowLabel: 'NĪP',
      placeholder: 'Ievadiet savu nodokļu maksātāja identifikācijas numuru'
    },
    customerEmail: {
      label: 'Ievadiet savu e-pastu',
      flowLabel: 'E-pasts',
      placeholder: 'Ievadiet savu e-pastu'
    },
    senderIban: {
      label: 'Aizpildiet savu IBAN',
      flowLabel: 'IBAN',
      placeholder: 'Aizpildiet savu IBAN'
    },
    shippingBuildingNumber: {
      label: 'Ievadiet ēkas numuru',
      flowLabel: 'Ēka Nr.',
      placeholder: 'Ēka Nr.'
    },
    shippingPostalCode: {
      label: 'Ievadiet pasta indeksu',
      flowLabel: 'Pasta indekss',
      placeholder: 'Pasta indekss'
    },
    shippingStreetName: {
      label: 'Ievadiet ielu',
      flowLabel: 'Iela',
      placeholder: 'Iela'
    },
    shippingLastName: {
      label: 'Ievadiet uzvārdu',
      flowLabel: 'Uzvārds',
      placeholder: 'Uzvārds'
    },
    shippingCountryCode: {
      label: 'Ievadiet valsti',
      flowLabel: 'Valsts',
      placeholder: 'izvēlieties valsti'
    },
    shippingRegion: {
      label: 'Ievadiet reģionu',
      flowLabel: 'Reģions',
      placeholder: 'Reģions'
    },
    shippingFlatNumber: {
      label: 'Ievadiet dzīvokļa numuru',
      flowLabel: 'Apt. nē.',
      placeholder: 'Apt. nē.'
    },
    shippingFirstName: {
      label: 'Ievadiet vārdu',
      flowLabel: 'Vārds',
      placeholder: 'Vārds'
    },
    shippingCity: {
      label: 'Ievadiet pilsētu',
      flowLabel: 'Pilsēta',
      placeholder: 'Pilsēta'
    }
  },
  survey: {
    skipSurvey: 'Izlaist aptauju',
    skipSurveyLabel: 'Izlaist aptaujas sadaļu',
    sectionLabel: 'Aptauja'
  }
}
